/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

export const apiTypes = {
  kafka: 'kafka'
};

export const codeLanguages = {
  java: 'Java',
  consoleConsumer: 'kafka-console-consumer',
  kafkaJS: 'kafkaJS',
  noderdKafka: 'node-rdkafka',
  kafkaPython: 'kafka-python',
  kafkacat: 'kafkacat'
};

export const SASL_MECHANISMS = {
  PLAIN: 'PLAIN',
  SCRAM256: 'SCRAM-SHA-256',
  SCRAM512: 'SCRAM-SHA-512'
};

export const SECURITY_PROTOCOLS = {
  SASL_PLAINTEXT: 'SASL_PLAINTEXT',
  SASL_SSL: 'SASL_SSL',
  SSL: 'SSL',
  PLAINTEXT: 'PLAINTEXT'
};

export const SASL_JAAS_MODULES = {
  SCRAM: 'org.apache.kafka.common.security.scram.ScramLoginModule',
  PLAIN: 'org.apache.kafka.common.security.plain.PlainLoginModule'
};

export const ROUTERTYPE = {
  HASH_ROUTER: 'hash',
  MEMORY_ROUTER: 'memory'
};
